var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashcardActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_23655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1632 2.15789C15.2382 1.8805 15.4201 1.64415 15.669 1.50062C15.9179 1.35709 16.2136 1.31809 16.4912 1.39217L30.2512 5.07674C30.5295 5.15073 30.7669 5.3322 30.9114 5.58124C31.0558 5.83028 31.0954 6.12649 31.0215 6.40474L25.7415 26.103C25.6666 26.3809 25.4843 26.6177 25.2349 26.7613C24.9854 26.9048 24.6892 26.9435 24.4112 26.8687L10.6512 23.1842C10.3734 23.1097 10.1365 22.928 9.99253 22.679C9.84854 22.43 9.80923 22.1341 9.88323 21.8562L15.1632 2.15789Z",
    stroke: "#1377D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.162 5.99316L2.1483 9.21374C1.87049 9.28822 1.63359 9.46989 1.4896 9.71887C1.34561 9.96786 1.3063 10.2638 1.3803 10.5417L6.65573 30.24C6.73068 30.5179 6.91291 30.7547 7.16236 30.8983C7.41181 31.0418 7.70807 31.0805 7.98601 31.0057L14.866 29.1635",
    stroke: "#1377D4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_23655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.200195 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcardActiveIcon);
export default __webpack_public_path__ + "static/media/flashcard-active-icon.efc136651755ba8406535b340c84506a.svg";
export { ForwardRef as ReactComponent };